export enum BannerView {
  Home = "Home",
  Ourstory = "Our story",
  Gallery = "Gallery",
  WellWishes = "Well Wishes",
  Schedule = "Schedule",
  WeddingParty = "Wedding Party",
  Q_And_A = "Q&A",
  Gifting = "Gifting",
  AsoEbi = "Aso Ebi",
}

export enum FooterView {
  RSVP = "RSVP",
  Asoebi = "Asoebi",
  GiftUs = "Gift us",
  FAQ = "FAQ",
}
